import { EditorType } from '@wix/a11y-adapters';
import { A11Y_RULES_EXPERIMENTS, AUTO_DOM_ORDER_DATE } from '../../../constants';
import { getIsLanguageDirectionMatchingDomDirection } from '../../../utils/get-is-language-direction-matching-dom-direction';
export function computeSiteDomOrderStatus(tools, _ref) {
  var _tools$logger;
  let {
    automaticDomOrderEnabled,
    isAutomaticallyCompleted,
    isManuallyCompleted,
    siteCreationDate,
    siteDomDirection,
    siteLanguage,
    editorType
  } = _ref;
  const siteCreatedAfterAutoDom = new Date(siteCreationDate) > AUTO_DOM_ORDER_DATE;
  const isRTLDomOrderEnabled = tools == null ? void 0 : tools.isExperimentEnabled(A11Y_RULES_EXPERIMENTS.ENABLE_RTL_DOM_ORDER);
  const shouldHideAfterUserChoice = tools == null ? void 0 : tools.isExperimentEnabled(A11Y_RULES_EXPERIMENTS.HIDE_SITE_DOM_ORDER);
  const isLanguageAndDomDirectionMisaligned = isRTLDomOrderEnabled && !getIsLanguageDirectionMatchingDomDirection({
    siteDomDirection,
    siteLanguage
  });
  const isHideInOdEditor = editorType === EditorType.OdEditor && shouldHideAfterUserChoice;
  let domOrderStatus;

  // Note: The order of these conditions is important
  if (isHideInOdEditor) {
    if (isLanguageAndDomDirectionMisaligned) {
      domOrderStatus = isManuallyCompleted ? 'passed' : 'failed';
    } else if (isManuallyCompleted && isLanguageAndDomDirectionMisaligned === false) {
      domOrderStatus = 'not-applicable';
    } else if (isAutomaticallyCompleted && automaticDomOrderEnabled) {
      domOrderStatus = 'not-applicable';
    } else {
      domOrderStatus = 'not-applicable';
    } // ORIGINAL LOGIC FOR STUDIO & CLASSIC EDITOR
  } else {
    if (isManuallyCompleted) {
      domOrderStatus = 'passed';
    } else if (isLanguageAndDomDirectionMisaligned) {
      domOrderStatus = 'failed';
    } else if (editorType === EditorType.Classic) {
      domOrderStatus = automaticDomOrderEnabled ? 'passed' : 'failed';
    } else if (siteCreatedAfterAutoDom) {
      domOrderStatus = automaticDomOrderEnabled ? 'passed' : 'failed';
    } else if (isAutomaticallyCompleted && automaticDomOrderEnabled) {
      domOrderStatus = 'passed';
    } else {
      domOrderStatus = 'failed';
    }
  }
  tools == null || (_tools$logger = tools.logger) == null || _tools$logger.info(`Running computeSiteDomOrderStatus`, {
    automaticDomOrderEnabled,
    domOrderStatus,
    editorType,
    isAutomaticallyCompleted,
    isHideInOdEditor,
    isLanguageAndDomDirectionMisaligned,
    isManuallyCompleted,
    siteCreatedAfterAutoDom,
    siteCreationDate,
    siteDomDirection,
    siteLanguage
  });
  return domOrderStatus;
}
//# sourceMappingURL=compute-site-dom-order-status.js.map